module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-happy-svgrepo-com.cb5199a5.svg";